import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=e707be94&scoped=true&"
import script from "./HistoryList.vue?vue&type=script&lang=ts&"
export * from "./HistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=e707be94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e707be94",
  null
  
)

export default component.exports